/* eslint-disable import/first */
import React from 'react';
import { Grid, IconButton, Typography } from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';
import { MobileNumberInput } from '../Profile/MobileNumberInput';
import css from './index.module.scss';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import { useNavigate, useLocation } from '@reach/router';
import classNames from 'classnames';

const LoginForm = ({ countryValidations, phoneError, phnNo, handleMobileChange, errorText }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  const handleClose = () => {
    navigate(
      location?.state?.oldLocation?.pathname || `/${intl.locale}/home`,

      { replace: true }
    );
  };

  return (
    <Grid>
      <Grid className={css.headerBar}>
        <Grid>
          <Grid className={css.headerText}>
            <Typography>
              <FormattedMessage id="loginWithYour" defaultMessage="Login with your" />
            </Typography>
            <Typography className={css.subHead}>
              <FormattedMessage id="loginMobileNo" defaultMessage="Mobile Number" />
            </Typography>
          </Grid>
          {/* <Grid className={classNames(css.headerText, css.boldText)}>
            <Typography>
              <FormattedMessage id="mobileNumberLogin" defaultMessage="Mobile Number" />
            </Typography>
          </Grid> */}
        </Grid>
        <Grid className={css.closeButtonContainer}>
          <IconButton>
            <IoMdClose className={css.closeIcon} onClick={handleClose} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid className={css.inputRoot}>
        <MobileNumberInput
          countryCode={countryValidations?.defaultCCode}
          value={phnNo}
          hideName={true}
          phoneError={phoneError}
          onChange={handleMobileChange}
          page="login"
          maxLength={countryValidations?.phnLength}
        />
      </Grid>
      <Grid className={css.exampleNo}>
        {!phnNo.match(countryValidations?.phnRegex) && phnNo !== '' ? (
          <Typography className={css.warningText}>{errorText}</Typography>
        ) : (
          ''
        )}
        {(phnNo.match(countryValidations?.phnRegex) || phnNo === '') && (
          <Typography>
            <FormattedMessage id="login_e_g" defaultMessage="E.g." />{' '}
            {countryValidations?.numberHint}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default LoginForm;
